import { styled } from 'styled-components';

import { Image } from 'src/components/image';
import { breakpointTablet } from 'src/styles/breakpoints';

export const StyledImage = styled(Image)`
  max-height: 77px;
  max-width: 100%;
  min-width: 0;
`;

export const StyledDefaultLogo = styled(Image)`
  max-width: 80px;

  @media (min-width: ${breakpointTablet}) {
    max-width: 120px;
  }
`;
